import jQuery from 'jquery'
import 'slick-carousel'
import YoutubeVideo from './YoutubeVideo'
import log from 'salvo-lite/log'

class Slider {
    constructor (theme, elem) {
        log.debug(this.constructor.name, 'Constructed', this)
        this.theme = theme
        this.elem = elem
        this.name = elem.dataset.componentName
        this.options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: true,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null,
            rows: 0
        }, JSON.parse(this.elem.dataset.slider ? this.elem.dataset.slider : '{}'))

        if (this.options.mobileOnly) {
            this.options.showBelow = 769
        }
        this._pauseAutoplayElems = this.elem.querySelectorAll('[data-pause-autoplay]')

        if (!this.options.dontInit) {
            this.init()
        }
    }

    onInit () {
    }

    goToSlide (x) {
        jQuery(this.elem).slick('slickGoTo', parseInt(x))
    }

    init () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            return false
        }

        let videoElems = this.elem.querySelectorAll('[data-youtube-video]')

        for (let videoElem of videoElems) {
            let instance = new YoutubeVideo(this.theme, videoElem)
            this.theme._components.push(instance)
            let id = videoElem.dataset.componentId
            if (id) {
                this.theme._componentsById[id] = instance
            }
            instance.init()
        }

        jQuery(this.elem).on('init', (e, slick) => {
            this.elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid && this.options.playVideos) {
                vid.play()
                vid.removeAttribute('poster')
            }
            if (slick.$slides.length > 0) {
                let youtubeVideo = slick.$slides[0].querySelector('[data-youtube-video]')
                if (youtubeVideo && this.options.playVideos) {
                    youtubeVideo.dispatchEvent(new Event('playVideo'))
                }
            }
        })

        jQuery(this.elem).not('.slick-initialized').slick(this.options)

        jQuery(this.elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            if (!slick.$slides[curSlide]) return false
            let vid = slick.$slides[curSlide].querySelector('video')
            if (vid) {
                vid.pause()
            }

            let youtubeVideo = slick.$slides[curSlide].querySelector('[data-youtube-video]')
            if (youtubeVideo) {
                youtubeVideo.dispatchEvent(new Event('pauseVideo'))
            }
        })

        jQuery(this.elem).on('afterChange', (e, slick, curSlide) => {
            if (!slick.$slides[curSlide]) return false
            let vid = slick.$slides[curSlide].querySelector('video')
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }

            let youtubeVideo = slick.$slides[curSlide].querySelector('[data-youtube-video]')
            if (youtubeVideo && this.options.playVideos) {
                youtubeVideo.dispatchEvent(new Event('playVideo'))
            }
        })

        if (this.options.autoplay) {
            for (let pauseElem of this._pauseAutoplayElems) {
                pauseElem.addEventListener('mouseenter', e => {
                    jQuery(this.elem).slick('slickPause')
                })
                pauseElem.addEventListener('mouseleave', e => {
                    jQuery(this.elem).slick('slickPlay')
                })
            }
        }

        let event = document.createEvent('HTMLEvents')
        event.initEvent('resize', true, false)
        document.dispatchEvent(event)
    }
}

export default Slider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slider.js